import { render, staticRenderFns } from "./getStatistics.vue?vue&type=template&id=8fc0649a&scoped=true&"
import script from "./getStatistics.vue?vue&type=script&lang=js&"
export * from "./getStatistics.vue?vue&type=script&lang=js&"
import style0 from "./getStatistics.vue?vue&type=style&index=0&id=8fc0649a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc0649a",
  null
  
)

export default component.exports